import CartDatalayer from '@curry/cart'
import CartModel from '../models/cart/cart'

export default class Cart {
  constructor({ config, transports }) {
    this.datalayer = new CartDatalayer({ config, transports });
    this.debounce = null;
  }

  view({ shop_id, embed_id, service, catalog_id }) {
    return new Promise((resolve, reject) => {
      const args = { 
        shop_id, 
        embed_id, 
        service, 
        catalog_id
      };

      if(['', null, undefined].includes(localStorage.getItem('cart_id'))) {
        args.fresh = 1;
      } 

      this.datalayer.models[0].findById({ args })
      .then((response) => {
        localStorage.setItem('cart_id', response.data.id);
        const cart = new CartModel(CartModel.fromJSON(response.data));
        cart.api = this;
        resolve(cart);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  post({ cartId, item }) {
    return new Promise((resolve, reject) => {
      const args = { cart_id: cartId, item };
      this.datalayer.models[0].save({ 
        args,
        item
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

  put({ cartId, itemId, item }) {
    return new Promise((resolve, reject) => {
      const args = { cart_id: cartId, item_id: itemId };
      this.datalayer.models[0].update({ 
        args,
        item 
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }

  delete({ cartId, itemId }) {
    return new Promise((resolve, reject) => {
      const args = { cart_id: cartId, item_id: itemId };
      this.datalayer.models[0].remove({ 
        args
      }).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  }
}